import React from 'react';
import { Link } from 'react-router-dom';

const PaymentSecurity = () => {
    return (
        <div className="min-h-screen" style={{background: 'linear-gradient(135deg, var(--app-color), #8B5CF6)'}}>
            {/* Header */}
            <header className="bg-white/90 backdrop-blur-sm border-b border-white/20">
                <div className="max-w-6xl mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{background: 'var(--app-color)'}}>
                                <span className="text-white font-bold text-lg">E</span>
                            </div>
                            <h1 className="text-xl font-bold text-gray-900">Esti.kz</h1>
                        </div>
                        <Link 
                            to="/" 
                            className="text-sm font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 flex items-center gap-2"
                            style={{background: 'var(--app-color)', color: 'white'}}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            Басты бетке оралу
                        </Link>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-6xl mx-auto px-4 py-8">
                <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-6 border border-white/20 mb-6">
                    <h1 className="text-3xl font-bold mb-6 text-gray-900">Төлем қауіпсіздігі</h1>
                    <div className="rounded-lg overflow-hidden border border-gray-200">
                        <iframe
                            src="https://esti.kz/esti_terms.pdf"
                            className="w-full h-[calc(100vh-300px)] min-h-[600px]"
                            title="PDF Viewer"
                        />
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-white/10 backdrop-blur-sm border-t border-white/20 py-6 mt-8">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="text-center">
                        <p className="text-white/80 text-sm">
                            © {new Date().getFullYear()} Esti.kz. Барлық құқықтар қорғалған.
                        </p>
                        <p className="text-xs text-white/60 mt-1">
                            Отбасы хрестоматиясы
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PaymentSecurity;